import { TimberBuyerDeliveryLocations } from '@features/TimberBuyer/DeliveryLocations/TimberBuyerDeliveryLocations'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  vsysNumber: z.string().optional(),
})

const TimberBuyerDeliveryLocationsRoute: React.FC = () => {
  const { timberBuyerId } = Route.useParams()
  const { vsysNumber } = Route.useSearch()
  return <TimberBuyerDeliveryLocations timberBuyerId={timberBuyerId} vsysNumber={vsysNumber} />
}

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/delivery-locations/')({
  component: TimberBuyerDeliveryLocationsRoute,
  validateSearch: searchSchema,
  staticData: {
    breadcrumb: 'Mottakssteder',
  },
})
